import StyledTableHead from 'Components/StyledTableHead'
import { fetchTicketTransferList } from 'Services/SalesManagement/Features/AffiliateProduct/affiliateProductSlice'
import useTypedSelector, { useAppDispatch } from 'Store'
import { datetimeFormatter } from 'Util/formatters'
import {
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material'
import { type FC, useEffect } from 'react'
import { t } from 'ttag'

interface TransferHistoryProps {
  ticketId: number
}

const TransferHistory: FC<TransferHistoryProps> = ({ ticketId }) => {
  const dispatch = useAppDispatch()

  const { singleTicketTransfers, transferHistoryLoading } = useTypedSelector(
    state => state.affiliateProduct
  )

  useEffect(() => {
    if (ticketId) {
      const params = {
        id: ticketId
      }
      dispatch(fetchTicketTransferList(params))
    }
  }, [])

  const isLoading = transferHistoryLoading === 'pending'

  return (
    <TableContainer component={Paper}>
      <Table>
        <StyledTableHead>
          <TableRow>
            <TableCell colSpan={4}>{t`Transfer history`}</TableCell>
          </TableRow>
        </StyledTableHead>
        {isLoading ? (
          <LinearProgress />
        ) : (
          <>
            <TableHead>
              <TableRow>
                <TableCell>{t`Created`}</TableCell>
                <TableCell>{t`Created by`}</TableCell>
                <TableCell>{t`Old max`}</TableCell>
                <TableCell>{t`New max`}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {singleTicketTransfers.length > 0 ? (
                <>
                  {singleTicketTransfers.map(row => (
                    <TableRow key={row.user.id}>
                      <TableCell>{datetimeFormatter(row.created)}</TableCell>
                      <TableCell>{row.user.email}</TableCell>
                      <TableCell>{row.old_max}</TableCell>
                      <TableCell>{row.new_max}</TableCell>
                    </TableRow>
                  ))}
                </>
              ) : (
                <TableRow>
                  <TableCell>{t`No Transfers`}</TableCell>
                </TableRow>
              )}
            </TableBody>
          </>
        )}
      </Table>
    </TableContainer>
  )
}

export { TransferHistory }
